<template src="./template.html" />
<script>

import DetailPage from 'src/modules/pages/detail-page'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  name: 'MeetingMinutesDetail',
  components: {
    'DetailPage': DetailPage
  },
  props: {
    'id': {
      type: String,
      default: ''
    },
    'mode': {
      type: String,
      default: ''
    },
    'data': {
      type: Object,
      default: () => {}
    },
    backLink: {
      type: [Object, String],
      default: '/meeting-minutes'
    }
  },
  data() {
    return {
      scaffolding: {
        'items': {
            'item-1': {
              type: 'Collumns',
              fieldName: '{this.root}',
              leftRightMode: true,
              css: [`col-12 col-md-8 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-4 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
              colBody: [
                {
                  'item-1': {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    css: [`col-0 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
                    colBody: [
                      {
                      },
                      {
                        'item-1': {
                          label: 'Tiêu đề',
                          type: 'TextField',
                          fieldName: 'title',
                          icon: 'fas fa-signature',
                          validation: 'required'
                        }
                      }
                    ]
                  },
                  'item-2': {
                    label: 'Nội dung cuộc họp',
                    type: 'WYSIWYG',
                    fieldName: 'content'
                  }
                },
                {
                  'item-1': {
                    label: 'Phòng ban',
                    type: 'Select',
                    fieldName: 'department',
                    datasource: {
                      options: [],
                      field: 'listDep',
                      label: 'name',
                      value: 'id'
                    },
                    icon: 'store',
                    sortBy: 'name',
                    mapOptions: true,
                    clearable: true,
                    validation: 'required',
                    onInput: this.changeDep,
                    useInput: true
                  },
                  'item-2': {
                    label: 'Ngày diễn ra cuộc họp',
                    type: 'DatePicker',
                    validation: 'required',
                    fieldName: 'dateTakePlace',
                    icon: 'date_range',
                    clearable: true
                  },
                  'item-3': {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    css: [`col-6 q-pr-xs`, `col-6 q-pl-xs`],
                    colBody: [
                      {
                        'item-1': {
                          label: 'Thời gian họp từ',
                          type: 'TimePicker',
                          fieldName: 'meetingStartTime',
                          clearable: true,
                          validation: {
                            required: true
                          }
                        }
                      },
                      {
                        'item-1': {
                          label: 'Thời gian họp đến',
                          type: 'TimePicker',
                          validation: 'required',
                          fieldName: 'meetingEndTime',
                          clearable: true
                        }
                      }
                    ]
                  },
                  'item-4': {
                    label: 'Địa điểm',
                    type: 'TextField',
                    fieldName: 'location',
                    clearable: true,
                    icon : 'fas fa-map-marked-alt',
                    validation: 'required'
                  },
                  'item-5': {
                    label: 'Chủ trì cuộc họp',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    sortBy: 'displayName',
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'required': true
                    },
                    field: 'host',
                    name: 'host',
                    fieldName: 'host',
                    icon: 'people',
                    clearable: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-6': {
                    label: 'Thành phần cuộc họp',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    sortBy: 'displayName',
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'required': true,
                      'email': true
                    },
                    field: 'participants',
                    name: 'participants',
                    fieldName: 'participants',
                    icon: 'people',
                    clearable: true,
                    useChipsMultiple: true,
                    multiple: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-7': {
                    label: 'Đối tác bên ngoài',
                    type: 'TextArea',
                    fieldName: 'otherParticipants',
                    icon: 'people',
                    clearable: true
                  },
                  'item-8': {
                    label: 'Chia sẻ',
                    fieldName: 'listShareUser',
                    type: 'Select',
                    multiple: true,
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    mapOptions: true,
                    useInput: true,
                    useChipsMultiple: true,
                    icon: 'people',
                    clearable: true
                  },
                  'item-9': {
                    label: 'Người tạo',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.value.createdBy`,
                    watch: true
                  },
                  'item-10': {
                    label: 'Ngày tạo',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.moment(this.value.createdTime.toDate()).fromNow()`,
                    watch: true
                  },
                  'item-11': {
                    label: 'Cập nhật cuối',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.moment(this.value.lastModifiedTime.toDate()).fromNow()`,
                    watch: true
                  }
                }
              ]
            },
            'item-2': {
              type: 'Uploader',
              fieldName: 'documentList',
              accept: '.jpg, .pdf, image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt',
              maxFileSize: 10485760,
              label: 'Tài liệu cuộc họp',
              class: 'q-px-md',
              header: [
                {
                  label: 'Tền file',
                  format: 'file.name'
                },
                {
                  format: 'file.__sizeLabel',
                  label: 'Dung lượng'
                },
                {
                  format: 'file.hasOwnProperty(\'uploadDate\') ? this.convertDate(file.uploadDate) : \'\'',
                  label: 'Ngày tải lên'
                }
              ],
              dialogScaffolding: {
                'item-1': {
                  type: 'FileInput',
                  fieldName: 'file',
                  validation: 'required',
                  accept: '.jpg, .pdf, image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt'
                }
              }
            }
          }
      },
      isLoading: true,
      isSubmiting: false,
      queryPath: ['MeetingMinutes', this.id ? this.id : this.$route.query.id ? this.$route.query.id : null],
      baseData: this.mode && this.mode === 'CREATE' ? {} : this.data,
      masterdata: {},
      listUser: []
    }
  },
  mounted() {
    this.fetchMasterdata()
    this.isLoading = false
  },
  computed: {
    computeScaffolding() {
      if(this.mode === 'CREATE') return this.scaffolding
      return this._.merge(this.scaffolding, {
        items: {
          'item-1': {
              type: 'Collumns',
              fieldName: '{this.root}',
              leftRightMode: true,
              css: [`col-12 col-md-8 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-4 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
              colBody: [
                {
                  'item-1': {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    css: [`col-0 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
                    colBody: [
                      {
                      },
                      {
                        'item-1': {
                          label: 'Tiêu đề',
                          type: 'TextField',
                          fieldName: 'title',
                          icon: 'fas fa-signature',
                          validation: 'required',
                          readonly: true
                        }
                      }
                    ]
                  },
                  'item-2': {
                    label: 'Nội dung cuộc họp',
                    type: 'WYSIWYG',
                    fieldName: 'content',
                    readonly: true
                  }
                },
                {
                  'item-1': {
                    label: 'Phòng ban',
                    type: 'Select',
                    fieldName: 'department',
                    datasource: {
                      options: [],
                      field: 'listDep',
                      label: 'name',
                      value: 'id'
                    },
                    icon: 'store',
                    sortBy: 'name',
                    mapOptions: true,
                    clearable: true,
                    validation: 'required',
                    onInput: this.changeDep,
                    useInput: true
                  },
                  'item-2': {
                    label: 'Ngày diễn ra cuộc họp',
                    type: 'DatePicker',
                    validation: 'required',
                    fieldName: 'dateTakePlace',
                    icon: 'date_range',
                    clearable: true
                  },
                  'item-3': {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    css: [`col-6 q-pr-xs`, `col-6 q-pl-xs`],
                    colBody: [
                      {
                        'item-1': {
                          label: 'Thời gian họp từ',
                          type: 'TimePicker',
                          fieldName: 'meetingStartTime',
                          clearable: true,
                          validation: {
                            required: true
                          }
                        }
                      },
                      {
                        'item-1': {
                          label: 'Thời gian họp đến',
                          type: 'TimePicker',
                          validation: 'required',
                          fieldName: 'meetingEndTime',
                          clearable: true
                        }
                      }
                    ]
                  },
                  'item-4': {
                    label: 'Địa điểm',
                    type: 'TextField',
                    fieldName: 'location',
                    clearable: true,
                    icon : 'fas fa-map-marked-alt',
                    validation: 'required'
                  },
                  'item-5': {
                    label: 'Chủ trì cuộc họp',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    sortBy: 'displayName',
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'required': true
                    },
                    field: 'host',
                    name: 'host',
                    fieldName: 'host',
                    icon: 'people',
                    clearable: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-6': {
                    label: 'Thành phần cuộc họp',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    sortBy: 'displayName',
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'required': true,
                      'email': true
                    },
                    field: 'participants',
                    name: 'participants',
                    fieldName: 'participants',
                    icon: 'people',
                    clearable: true,
                    useChipsMultiple: true,
                    multiple: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-7': {
                    label: 'Đối tác bên ngoài',
                    type: 'TextArea',
                    fieldName: 'otherParticipants',
                    icon: 'people',
                    clearable: true
                  },
                  'item-8': {
                    label: 'Chia sẻ',
                    fieldName: 'listShareUser',
                    type: 'Select',
                    multiple: true,
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    mapOptions: true,
                    useInput: true,
                    useChipsMultiple: true,
                    icon: 'people',
                    clearable: true
                  },
                  'item-9': {
                    label: 'Người tạo',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.value.createdBy`,
                    watch: true
                  },
                  'item-10': {
                    label: 'Ngày tạo',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.moment(this.value.createdTime.toDate()).fromNow()`,
                    watch: true
                  },
                  'item-11': {
                    label: 'Cập nhật cuối',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.moment(this.value.lastModifiedTime.toDate()).fromNow()`,
                    watch: true
                  }
                }
              ]
            },
            'item-2': {
              type: 'Uploader',
              fieldName: 'documentList',
              accept: '.jpg, .pdf, image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt',
              maxFileSize: 10485760,
              label: 'Tài liệu cuộc họp',
              class: 'q-px-md',
              header: [
                {
                  label: 'Tền file',
                  format: 'file.name'
                },
                {
                  format: 'file.__sizeLabel',
                  label: 'Dung lượng'
                },
                {
                  format: 'file.hasOwnProperty(\'uploadDate\') ? this.convertDate(file.uploadDate) : \'\'',
                  label: 'Ngày tải lên'
                }
              ],
              dialogScaffolding: {
                'item-1': {
                  type: 'FileInput',
                  fieldName: 'file',
                  validation: 'required',
                  accept: '.jpg, .pdf, image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt'
                }
              },
              canDelete: false
            }
        }
      })
    },
    ...mapGetters([
      'user',
      'userProfile'
    ])
  },
  methods: {
    async handlerSubmit(payload, resolve, reject) {
      let vm = this
      let submitModel = {
        id: payload.id,
        data: payload.data
      }
      await vm.$command.execute('updateMeetingMinutes', submitModel).then(res => resolve(res)).catch(err => reject(err))
    },
    async fetchMasterdata() {
      this.$query(['MasterData', 'Department']).then(res => {
        this.scaffolding.items['item-1'].colBody[1]['item-1'].datasource.options = this._.values(this._.omit(res,'metaData')) || []
      })
      this.$query(['Users', 'UsersIndex']).then(res => {
        // phe duyet
        this.listUser = res.list
        this.scaffolding.items['item-1'].colBody[1]['item-5'].datasource.options = res.list
        this.scaffolding.items['item-1'].colBody[1]['item-6'].datasource.options = res.list
        this.scaffolding.items['item-1'].colBody[1]['item-8'].datasource.options = res.list
      })
    },
    detailPageFetched(data) {
      this.baseData = data
    },
    changeDep(value) {
      let bu = (this.R.path(['listBU'], this.masterdata) || []).filter(item => item.value === this.R.path(['buID'], value))
      if(bu.length > 0 && this.$refs.detailPage) {
        this.$refs.detailPage.$emit('onUpdateData', { bu: bu[0] }, true)
      }
    },
    assignToMe(components, value, options) {
      if(this.$store.getters.user.email) {
        components.$emit('input', this.$store.getters.user.email)
      }
    }
  }
}
</script>
